import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/functions'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

const firebaseConfig = {
  apiKey: "AIzaSyDzGJF0ZuiCzSmGlYxEXzjIpgQbcA9qZa4",
  authDomain: "p4cloud-51c31.firebaseapp.com",
  databaseURL: "https://p4cloud-51c31.firebaseio.com",
  projectId: "p4cloud-51c31",
  storageBucket: "p4cloud-51c31.appspot.com",
  messagingSenderId: "797718118085",
  appId: "1:797718118085:web:16c80ac7f5331435ab3aac"
};

firebase.initializeApp(firebaseConfig)

export default firebase
